import React, { Component } from 'react'
import { connect } from 'react-redux'
import Table from 'react-bootstrap/lib/Table'
import Modal from 'bisu-react-modal'
import acc from 'accounting'

import FormFee from './form-fee'
import DetailItem from './detail-item'
import { savePresetFee, deletePresetFee } from './actions'

class Details extends Component {

  constructor(props) {
    super(props)
    this.state = {
      openForm: false,
      item: null,
    }
  }

  _openForm = () => {
    this.setState({
      openForm: true,
      item: null,
    })
  }

  _closeForm = () => {
    this.setState({
      openForm: false,
    })
  }

  _onSubmit = (payload) => {
    const { dispatch, id } = this.props
    dispatch(savePresetFee(id, payload))
      .then((res) => {
        if (!res.error) {
          this._closeForm()
        }
      })
  }

  _onDelete = (item) => {
    const { dispatch, id } = this.props
    dispatch(deletePresetFee(id, item.get('id')))
      .then((res) => {
        if (!res.error) {
          this._closeForm()
        }
      })
  }

  _onSelectItem = (item) => {
    this.setState({
      openForm: true,
      item: item,
    })
  }

  _renderForm() {
    const { openForm, item } = this.state
    const { __fees, pending } = this.props

    return (
      <Modal isOpen={openForm} handleClose={this._closeForm}>
        <FormFee
          fees={__fees}
          item={item}
          onSubmit={this._onSubmit}
          onDelete={this._onDelete}
          pending={pending}
        />
      </Modal>
    )
  }

  render() {
    const { items } = this.props
    let total = 0

    return (
      <div>
        {this._renderForm()}
        <div className="m-b-20">
          <button type="button" onClick={this._openForm} className="btn btn-info">Add Fee</button>
        </div>
        <Table condensed hover>
          <thead>
            <tr>
              <th></th>
              <th>Fee Code</th>
              <th>Fee Name</th>
              <th>UACS</th>
              <th>Acct. Code</th>
              <th className="text-right">Amount (Php)</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, k) => {
              total += item.get('amount') - 0
              return (
                <DetailItem key={k} item={item} k={k} onSelectItem={this._onSelectItem} />
              )
            })}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan="5" className="text-right">TOTAL: </th>
              <th className="text-right">{acc.formatNumber(total, 2)}</th>
            </tr>
          </tfoot>
        </Table>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    __fees: state.fee.get('items'),
  }
}

export default connect(mapStateToProps)(Details)



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/details.js